/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

function checkGuaranteedItemQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function checkGuaranteedItemInput(productRecordId: number): IDataServiceRequest {
    const query = checkGuaranteedItemQuery();
    return query.createDataServiceRequestForOperation(
        'CheckGuaranteedItem',
        false,
        DataServiceEntities.GuaranteedItemResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGuaranteedItemResponse' },
        {
            productRecordId: productRecordId
        }
    );
}

export function checkGuaranteedItemAsync(
    context: IContext,
    productRecordId: number
): AsyncResult<DataServiceEntities.IGuaranteedItemResponse> {
    const request = checkGuaranteedItemInput(productRecordId);
    return callActionOrExecute<DataServiceEntities.IGuaranteedItemResponse>(request, context.callerContext);
}

function getMultiUnitOfMeasureConversionQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getMultiUnitOfMeasureConversionInput(itemRecordIds: number[]): IDataServiceRequest {
    const query = getMultiUnitOfMeasureConversionQuery();
    return query.createDataServiceRequestForOperation(
        'GetMultiUnitOfMeasureConversion',
        true,
        DataServiceEntities.GetMultiUnitOfMeasureConversionResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetMultiUnitOfMeasureConversionResponse' },
        {
            itemRecordIds: itemRecordIds
        }
    );
}

export function getMultiUnitOfMeasureConversionAsync(
    context: IContext,
    itemRecordIds: number[]
): AsyncResult<DataServiceEntities.IGetMultiUnitOfMeasureConversionResponse> {
    const request = getMultiUnitOfMeasureConversionInput(itemRecordIds);
    return callActionOrExecute<DataServiceEntities.IGetMultiUnitOfMeasureConversionResponse>(request, context.callerContext);
}

function getSingleUnitOfMeasureConversionQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getSingleUnitOfMeasureConversionInput(productRecordId: number): IDataServiceRequest {
    const query = getSingleUnitOfMeasureConversionQuery();
    return query.createDataServiceRequestForOperation(
        'GetSingleUnitOfMeasureConversion',
        false,
        DataServiceEntities.GetSingleUnitOfMeasureConversionResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetSingleUnitOfMeasureConversionResponse' },
        {
            productRecordId: productRecordId
        }
    );
}

export function getSingleUnitOfMeasureConversionAsync(
    context: IContext,
    productRecordId: number
): AsyncResult<DataServiceEntities.IGetSingleUnitOfMeasureConversionResponse> {
    const request = getSingleUnitOfMeasureConversionInput(productRecordId);
    return callActionOrExecute<DataServiceEntities.IGetSingleUnitOfMeasureConversionResponse>(request, context.callerContext);
}

function getMultipleStockStatusQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getMultipleStockStatusInput(itemRecIds: number[]): IDataServiceRequest {
    const query = getMultipleStockStatusQuery();
    return query.createDataServiceRequestForOperation(
        'GetMultipleStockStatus',
        true,
        DataServiceEntities.GetMultipleStockStatusResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetMultipleStockStatusResponse' },
        {
            itemRecIds: itemRecIds
        }
    );
}

export function getMultipleStockStatusAsync(
    context: IContext,
    itemRecIds: number[]
): AsyncResult<DataServiceEntities.IGetMultipleStockStatusResponse> {
    const request = getMultipleStockStatusInput(itemRecIds);
    return callActionOrExecute<DataServiceEntities.IGetMultipleStockStatusResponse>(request, context.callerContext);
}

function getStockStatusQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getStockStatusInput(itemRecId: number): IDataServiceRequest {
    const query = getStockStatusQuery();
    return query.createDataServiceRequestForOperation(
        'GetStockStatus',
        false,
        DataServiceEntities.GetStockStatusResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetStockStatusResponse' },
        {
            itemRecId: itemRecId
        }
    );
}

export function getStockStatusAsync(context: IContext, itemRecId: number): AsyncResult<DataServiceEntities.IGetStockStatusResponse> {
    const request = getStockStatusInput(itemRecId);
    return callActionOrExecute<DataServiceEntities.IGetStockStatusResponse>(request, context.callerContext);
}

function getCustomerWarehousesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getCustomerWarehousesInput(customerId: string): IDataServiceRequest {
    const query = getCustomerWarehousesQuery();
    return query.createDataServiceRequestForOperation(
        'GetCustomerWarehouses',
        false,
        DataServiceEntities.GetCustomerWarehousesResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetCustomerWarehousesResponse' },
        {
            customerId: customerId
        }
    );
}

export function getCustomerWarehousesAsync(
    context: IContext,
    customerId: string
): AsyncResult<DataServiceEntities.IGetCustomerWarehousesResponse> {
    const request = getCustomerWarehousesInput(customerId);
    return callActionOrExecute<DataServiceEntities.IGetCustomerWarehousesResponse>(request, context.callerContext);
}

function getCustomerWarehouses_V2Query(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getCustomerWarehouses_V2Input(customerId: string): IDataServiceRequest {
    const query = getCustomerWarehouses_V2Query();
    return query.createDataServiceRequestForOperation(
        'GetCustomerWarehouses_V2',
        false,
        DataServiceEntities.GetCustomerWarehousesResponse_V2ExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetCustomerWarehousesResponse_V2' },
        {
            customerId: customerId
        }
    );
}

export function getCustomerWarehouses_V2Async(
    context: IContext,
    customerId: string
): AsyncResult<DataServiceEntities.IGetCustomerWarehousesResponse_V2> {
    const request = getCustomerWarehouses_V2Input(customerId);
    return callActionOrExecute<DataServiceEntities.IGetCustomerWarehousesResponse_V2>(request, context.callerContext);
}

function getStockHoldStatusQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getStockHoldStatusInput(customerId: string, itemId: string): IDataServiceRequest {
    const query = getStockHoldStatusQuery();
    return query.createDataServiceRequestForOperation(
        'GetStockHoldStatus',
        false,
        DataServiceEntities.GetStockHoldStatusResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetStockHoldStatusResponse' },
        {
            customerId: customerId,
            itemId: itemId
        }
    );
}

export function getStockHoldStatusAsync(
    context: IContext,
    customerId: string,
    itemId: string
): AsyncResult<DataServiceEntities.IGetStockHoldStatusResponse> {
    const request = getStockHoldStatusInput(customerId, itemId);
    return callActionOrExecute<DataServiceEntities.IGetStockHoldStatusResponse>(request, context.callerContext);
}

function getMilSearchResultsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getMilSearchResultsInput(
    searchTerm: string,
    pageSize: number,
    filters: string[],
    sort: string,
    nextPageNum: string
): IDataServiceRequest {
    const query = getMilSearchResultsQuery();
    return query.createDataServiceRequestForOperation(
        'GetMilSearchResults',
        true,
        DataServiceEntities.GetSearchResultsResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetSearchResultsResponse' },
        {
            searchTerm: searchTerm,
            pageSize: pageSize,
            filters: filters,
            sort: sort,
            nextPageNum: nextPageNum
        }
    );
}

export function getMilSearchResultsAsync(
    context: IContext,
    searchTerm: string,
    pageSize: number,
    filters: string[],
    sort: string,
    nextPageNum: string
): AsyncResult<DataServiceEntities.IGetSearchResultsResponse> {
    const request = getMilSearchResultsInput(searchTerm, pageSize, filters, sort, nextPageNum);
    return callActionOrExecute<DataServiceEntities.IGetSearchResultsResponse>(request, context.callerContext);
}

function getMilFilteredFacetsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getMilFilteredFacetsInput(searchTerm: string, facets: string, facetTerm: string, filters: string[]): IDataServiceRequest {
    const query = getMilFilteredFacetsQuery();
    return query.createDataServiceRequestForOperation(
        'GetMilFilteredFacets',
        true,
        DataServiceEntities.GetFacetValueResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetFacetValueResponse' },
        {
            searchTerm: searchTerm,
            facets: facets,
            facetTerm: facetTerm,
            filters: filters
        }
    );
}

export function getMilFilteredFacetsAsync(
    context: IContext,
    searchTerm: string,
    facets: string,
    facetTerm: string,
    filters: string[]
): AsyncResult<DataServiceEntities.IGetFacetValueResponse> {
    const request = getMilFilteredFacetsInput(searchTerm, facets, facetTerm, filters);
    return callActionOrExecute<DataServiceEntities.IGetFacetValueResponse>(request, context.callerContext);
}

function getMilSearchSuggestionsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getMilSearchSuggestionsInput(searchTerm: string, resultsSize: number): IDataServiceRequest {
    const query = getMilSearchSuggestionsQuery();
    return query.createDataServiceRequestForOperation(
        'GetMilSearchSuggestions',
        true,
        DataServiceEntities.GetSearchSuggestionsResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetSearchSuggestionsResponse' },
        {
            searchTerm: searchTerm,
            resultsSize: resultsSize
        }
    );
}

export function getMilSearchSuggestionsAsync(
    context: IContext,
    searchTerm: string,
    resultsSize: number
): AsyncResult<DataServiceEntities.IGetSearchSuggestionsResponse> {
    const request = getMilSearchSuggestionsInput(searchTerm, resultsSize);
    return callActionOrExecute<DataServiceEntities.IGetSearchSuggestionsResponse>(request, context.callerContext);
}
